//External import group
import moment from "moment";
import { Typography as typography_antd } from "antd";
import {
  Card,
  Grid,
  Typography,
  FormControl,
  MenuItem,
  Select,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";
//Internal import group
import React, { useState, useEffect } from "react";
import ApplyLeaveStyle from "../../Components/ApplyLeaveStyle";
import Check from "../../assets/check-svgrepo-com.svg";
import "./index.css";
import { fetchSubLeaveTypeData } from "../../redux/slice/subLeaveType.js";
import { fetchLeaveTypeData } from "../../redux/slice/leaveType.js";
import { fetchLeaveDurationData } from "../../redux/slice/leaveDuration.js";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeaveSummaryData } from "../../redux/slice/getLeaveSummary.js";
import { fetchHolidayData } from "../../redux/slice/getHolidayData.js";
import dayjs from "dayjs";
import { jwtDecode } from 'jwt-decode';
import { logout, setToken, setUserData } from "../../redux/slice/authSlice.js";
import CryptoJS from "crypto-js";

const { default: env } = require("../../config/env.js");
const { Title, Text } = typography_antd;
const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

/********************************
 * use:used for applay leaves page
 * param:{}
 * author:spectus infotech
 ********************************/
export default function ApplyLeave(props) {
  const navigate = useNavigate();
  const [toDate, setToDate] = useState();
  const [fromDate, setFromDate] = useState();
  const [remainingLeaves, setRemainingLeaves] = useState({});
  const [leaveData, setLeaveData] = useState([]);
  const [subLeaveData, setSubLeaveData] = useState([]);
  const [durationsData, setDurationsData] = useState([]);
  const [open, setOpen] = useState(false);
  const [daycount, setDayCount] = useState(0);
  const [selectedLeaves, setSelectedLeaves] = useState("");
  const [leaveSummaryId, setLeaveSummaryId] = useState("");
  const [preventDoubleClick, setPreventDoubleClick] = useState(false);
  const [durationTrack, setDurationTrack] = useState("");
  const [holidayData, setHolidayData] = useState([]);
  const [subLeave, setSubLeave] = useState("");
  const [durationData, setDurationData] = useState("");
  const [reason, setReason] = useState("");
  const [leaveType, setLeaveType] = useState("");

  const [validationErrors, setValidationErrors] = useState({
    fromDate: "",
    toDate: "",
    selectedLeaves: "",
    selectSubLeave: "",
    duration: "",
    reason: "",
  });

  const convertedData = subLeaveData?.map((item) => ({
    value: item?.value,
    name: item?.label,
  }));

  const token = useSelector((state) => state.auth.token);

  let decode = jwtDecode(token);
  let Roles = props?.role;

  const dispatch = useDispatch();
  const state = useSelector((state) => state);

  useEffect(() => {
    if (token) {
      const obj = {
        roleId: Roles,
        token: token
      }
      dispatch(fetchSubLeaveTypeData(token));
      dispatch(fetchLeaveTypeData(token));
      dispatch(fetchLeaveDurationData(token));
      dispatch(fetchHolidayData(obj));
    }
  }, [token]);

  useEffect(() => {
    if (decode?.id) {
      const obj = {
        id: decode?.id,
        token: token,
      }
      dispatch(fetchLeaveSummaryData(obj));
    }
  }, [decode?.id]);


  useEffect(() => {
    if (state?.getLeaveType?.data?.status === 555 || state?.getLeaveType?.data?.status === 501
      || state?.getSubLeaveType?.data?.status === 555 || state?.getSubLeaveType?.data?.status === 501
      || state?.getLeaveDuration?.data?.status === 555 || state?.getLeaveDuration?.data?.status === 501
      || state?.getLeaveSummary?.data?.status === 555 || state?.getLeaveSummary?.data?.status === 501
      || state?.getHoliday?.data?.status === 555 || state?.getHoliday?.data?.status === 501
    ) {
      dispatch(setToken(null));
      dispatch(setUserData(null));
      toast.error("Session expire, Please LogIn!", {
        position: toast.POSITION.TOP_RIGHT,
        toastId: "1",
      });
      Navigate("/login")
    }
    if (state?.getLeaveType?.data?.data) {
      setLeaveData(state?.getLeaveType?.data?.data);
    }
    if (state?.getSubLeaveType?.data?.data) {
      setSubLeaveData(state?.getSubLeaveType?.data?.data);
    }
    if (state?.getLeaveDuration?.data?.data) {
      setDurationsData(state?.getLeaveDuration?.data?.data);
    }
    if (state?.getLeaveSummary?.data?.data) {
      setRemainingLeaves(
        state?.getLeaveSummary?.data?.data[0]?.remaining_leave_summary
      );
      setLeaveSummaryId(
        state?.getLeaveSummary?.data?.data[0]?.remaining_leave_summary?.id
      );
    }
    if (state?.getHoliday?.data?.data) {
      const holidayData = [];

      state?.getHoliday?.data?.data?.forEach((doc) => {
        const roleArray = doc?.role;
        if (roleArray?.includes(Roles)) {
          const dateOnly = moment(doc.holiday_date).format("YYYY-MM-DD");

          holidayData.push({
            date: `${dateOnly} 00:00:00`,
            title: doc.holiday_title,
          });
        }
        setHolidayData(holidayData);
      });
    }
  }, [state]);
  useEffect(() => {
    let arr = [];
    if (fromDate < toDate || daycount > 1) {
      arr = durationsData.filter(
        (ele) => ele.leave_duration_title === "Full Day"
      );
      setDurationsData(arr);
    } else {
      setDurationsData(state?.getLeaveDuration?.data?.data);
    }
  }, [daycount, fromDate, toDate]);

  useEffect(() => {
    if (fromDate && toDate) {
      const newStartDate = new Date(fromDate);
      const newEndDate = new Date(toDate);
      let result = moment(newEndDate).diff(newStartDate, "days");
      let count = 0;
      let curDate = new Date(newStartDate.getTime());
      while (curDate <= newEndDate) {
        var dayOfWeek = curDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          count++;
        }
        curDate.setDate(curDate.getDate() + 1);
      }
      let counter = 0;

      holidayData &&
        holidayData.forEach((doc) => {
          let newDate = new Date(doc.date);
          if (newDate >= newStartDate && newDate <= newEndDate) {
            counter++;
          }
        });

      if (newEndDate < newStartDate) {
      } else if (
        result === 0 &&
        durationTrack === 2 &&
        counter === 0 &&
        dayOfWeek !== 0 &&
        dayOfWeek !== 6
      ) {
        setDayCount(0.5);
      } else if (
        result === 0 &&
        durationTrack === 3 &&
        counter === 0 &&
        dayOfWeek !== 0 &&
        dayOfWeek !== 6
      ) {
        setDayCount(0.5);
      } else if (count > 0) {
        setDayCount(count - counter);
      } else if (count === 0) {
        setDayCount(count);
      } else {
        setDayCount(result + 1 - counter);
      }
    }
  }, [fromDate, toDate, durationTrack]);



  const onFinish = async () => {
    const data = {
      fromDate: fromDate.$d,
      duration: durationData,
      toDate: toDate.$d,
      leave_sub_type: subLeave,
      leave_type: leaveType,
      leave_reason: reason,
    };
    if (leaveSummaryId === "") {
      toast.warning("Leaves are not assigned yet!", { toastId: "1" });
    } else {
      setPreventDoubleClick(true);

      const days = daycount;
      const tempLeaveData = leaveData.filter(
        (item) => item.id === data.leave_type
      );
      const tempDurationData = durationsData.filter(
        (item) => item?.id === data?.duration
      );
      const applyData = {
        days,
        applied_user_doc_id: decode?.id,
        applied_user_name: props?.userData?.name,
        leave_duration_id: data.duration,
        action_taken_by: "",
        leave_reason: data.leave_reason,
        leave_status: "Pending",
        leave_type_id: data.leave_type,
        start_date: data.fromDate,
        leave_sub_type: data.leave_sub_type,
        end_date: data.toDate,
        leave_type_label: tempLeaveData[0]?.leave_title,
        leave_duration_label: tempDurationData[0]?.leave_duration_title,
        date: new Date(),
      };

      try {

        const plaindata = {
          userId: decode?.id,
          userName: props?.userData?.name,
          startDate: data.fromDate,
          endDate: data.toDate,
          leaveType: data.leave_type,
          leaveSubType: data.leave_sub_type,
          leaveDuration: data.duration,
          leaveReason: data.leave_reason,
          days: days,
        }

        //Encrypt api endpoint
        const addLeaves = CryptoJS.SHA256("/addLeaves" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

        // Encrypt data
        const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(plaindata), SECRET_KEY).toString();;

        const response = await fetch(`${env.backend_api_endpoint}/${addLeaves}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
          body: JSON.stringify({ encryptedData: encryptedBody }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login")
          }
          if (errorData.status === 400) {
            toast.error(errorData.message, {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
          }

        }
        if (response.ok) {
          const successData = await response.json();
          if (successData.status === 200) {
            setOpen(true);
          }
        }
      } catch (error) {
        console.error("Error Add Leave Summury in:", error.message);
      }


      var templateParams = {
        date: `${applyData.start_date.toLocaleDateString([], {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })} to ${applyData.end_date.toLocaleDateString([], {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })}`,
        to_name: applyData.applied_user_name,
        leave_type: applyData.leave_type_label,
        sub_leave_type: applyData.leave_sub_type,
        duration:
          applyData.leave_duration_label === "Second Half" || "First Half"
            ? "Half Day"
            : applyData.days + " days",
        duration_period: applyData.leave_duration_label,
        reason: applyData.leave_reason,
        to_email: "hr@spectusinfotech.com",
        subject: `Leave Applied by ${applyData.applied_user_name} ${env.subject_mode}`,
        type: "apply_leave",
        from_email: env.basic_email_params.from_email,
      };

      await axios.post(`${env.backend_api_endpoint}/send-email`, {
        ...templateParams,
      });
    }
    setPreventDoubleClick(false);
  };

  const handleCancel = () => {
    setOpen(false);
    navigate("/myleaves");
    window.location.reload();
  };

  const handleSubmit = () => {
    setValidationErrors({
      fromDate: "",
      toDate: "",
      selectedLeaves: "",
      selectSubLeave: "",
      duration: "",
      reason: "",
    });

    let isValid = true;
    const errors = {
      fromDate: "",
      toDate: "",
      selectedLeaves: "",
      selectSubLeave: "",
      duration: "",
      reason: "",
    };

    if (!fromDate) {
      errors.fromDate = "Please select a start date.";
      isValid = false;
    }
    if (!toDate) {
      errors.toDate = "Please select an end date.";
      isValid = false;
    }
    if (!leaveType) {
      errors.selectedLeaves = "Please select a leave type.";
      isValid = false;
    }
    if (!subLeave) {
      errors.selectSubLeave = "Please select a sub leave type.";
      isValid = false;
    }
    if (!durationData) {
      errors.duration = "Please select a duration.";
      isValid = false;
    }
    if (!reason.trim()) {
      errors.reason = "Please enter leave reason.";
      isValid = false;
    } else if (!reason) {
      errors.reason = "Please enter leave reason.";
      isValid = false;
    } else {
      delete errors.reason;
    }
    if (!isValid) {
      setValidationErrors(errors);
      return;
    } else {
      onFinish();
    }
  };
  const handleChange = (e) => {
    const selectValue = e.target.value;
    const selectedSubLeave = subLeaveData?.find(
      (item) => item?.id === selectValue
    );
    if (selectedSubLeave) {
      setSubLeave(selectedSubLeave.id);
      setSelectedLeaves(selectedSubLeave.sub_leave_type_id);
    }
  };

  const handleFormDateChange = (newDate) => {
    if (newDate && toDate && dayjs(toDate).isBefore(dayjs(newDate))) {
      setFromDate(newDate);
      setToDate(newDate);
    } else {
      setFromDate(newDate);
    }
  }
  /********************************
   * use:used for render ui
   * author:spectus infotech
   *********************************/
  return (
    <ApplyLeaveStyle>
      <Card
        sx={{
          margin: "10px",
          // minHeight:"85vh",
          height: "calc(100vh - 75px)",
          overflowY: "auto"
        }}
      >
        <Title
          level={2}
          style={{
            color: "#244DA0",
            fontFamily: "ImportedMilliardBold",
            padding: "16px 0px 0px 16px",
            marginTop: "16px",
          }}
        >
          Apply Leave
        </Title>
        <form>
          <Grid
            container
            spacing={2}
            style={{ marginTop: "5px", marginLeft: "5px" }}
          >
            <Grid item md={3} sm={4} xs={8}>
              <FormControl variant="outlined" fullWidth sx={{ '& .MuiInputBase-root.MuiOutlinedInput-root': { height: "40px" } }}>
                <Typography className="label_text">
                  From Date <span style={{ color: "red" }}>*</span>
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={fromDate}
                    format="DD-MM-YYYY"
                    onChange={handleFormDateChange}
                    renderInput={(params) => <TextField {...params} />}
                  />
                  {!fromDate && validationErrors.fromDate && (
                    <Typography color="red">
                      {validationErrors.fromDate}
                    </Typography>
                  )}
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item md={3} sm={4} xs={8}>
              <FormControl variant="outlined" fullWidth sx={{ '& .MuiInputBase-root.MuiOutlinedInput-root': { height: "40px" } }}>
                <Typography className="label_text">
                  To Date <span style={{ color: "red" }}>*</span>
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    minDate={fromDate}
                    value={toDate}
                    format="DD-MM-YYYY"
                    onChange={(newDate) => setToDate(newDate)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                  {!toDate && validationErrors.toDate && (
                    <Typography color="red">
                      {validationErrors.toDate}
                    </Typography>
                  )}
                </LocalizationProvider>
              </FormControl>
            </Grid>

            <Grid item md={3} sm={4} xs={2} style={{ marginTop: "36px" }}>
              {daycount >= 0 && fromDate && toDate ? (
                <Typography
                  style={{
                    position: "absolute",
                  }}
                >{`${daycount} days`}</Typography>
              ) : (
                ""
              )}

              {selectedLeaves in remainingLeaves && (
                <p
                  style={{
                    marginTop: "25px",
                    color:
                      selectedLeaves in remainingLeaves &&
                        remainingLeaves[selectedLeaves] < daycount
                        ? "red"
                        : "black",
                  }}
                >
                  {`${Number(
                    remainingLeaves[selectedLeaves]
                  )} leaves remaining`}
                </p>
              )}
            </Grid>

            <Grid item md={6} sm={4} xs={9}>
              <FormControl fullWidth variant="outlined" sx={{ '& .MuiInputBase-root.MuiOutlinedInput-root': { height: "40px" } }}>
                <Typography id="leave-type-label" className="label_text">
                  Leave Type <span style={{ color: "red" }}>*</span>
                </Typography>

                <Select
                  labelId="leave-type-label"
                  id="leave_type"
                  onChange={(e) => setLeaveType(e.target.value)}
                  displayEmpty
                  renderValue={
                    leaveType !== ""
                      ? undefined
                      : () => (
                        <span style={{ color: "gray" }}>
                          Select leave type
                        </span>
                      )
                  }
                >
                  {leaveData.map((leave) => (
                    <MenuItem key={leave.id} value={leave.id}>
                      {leave.leave_title}
                    </MenuItem>
                  ))}
                </Select>
                {!leaveType && validationErrors.selectedLeaves && (
                  <Typography color="red">
                    {validationErrors.selectedLeaves}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item md={6}></Grid>
            <Grid item md={6} sm={4} xs={9}>
              <FormControl fullWidth variant="outlined" sx={{ '& .MuiInputBase-root.MuiOutlinedInput-root': { height: "40px" } }}>
                <Typography id="leave-type-label" className="label_text">
                  Sub Leave Type <span style={{ color: "red" }}>*</span>
                </Typography>
                <Select
                  labelId="sub-leave-type-label"
                  id="sub_leave_type"
                  onChange={handleChange}
                  displayEmpty
                  renderValue={
                    subLeave !== ""
                      ? undefined
                      : () => (
                        <span style={{ color: "gray" }}>
                          Select sub leave type
                        </span>
                      )
                  }
                >
                  {subLeaveData?.map((subLeave) => (
                    <MenuItem
                      key={subLeave?.id}
                      value={subLeave?.id}
                      name={subLeave?.sub_leave_title}
                    >
                      {subLeave?.sub_leave_title}
                    </MenuItem>
                  ))}
                </Select>
                {!subLeave && validationErrors.selectSubLeave && (
                  <Typography color="red">
                    {validationErrors.selectSubLeave}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item md={6}></Grid>
            <Grid item md={6} sm={4} xs={9}>
              <FormControl fullWidth variant="outlined" sx={{ '& .MuiInputBase-root.MuiOutlinedInput-root': { height: "40px" } }}>
                <Typography id="leave-type-label" className="label_text">
                  Duration <span style={{ color: "red" }}>*</span>
                </Typography>
                <Select
                  labelId="duration-label"
                  id="duration"
                  onChange={(e) => {
                    setDurationData(e.target.value);
                    setDurationTrack(e.target.value);
                  }}
                  displayEmpty
                  renderValue={
                    durationData !== ""
                      ? undefined
                      : () => (
                        <span style={{ color: "gray" }}>Select duration</span>
                      )
                  }
                >
                  {durationsData?.map((duration) => (
                    <MenuItem key={duration?.id} value={duration?.id}>
                      {duration.leave_duration_title}
                    </MenuItem>
                  ))}
                </Select>
                {!durationData && validationErrors.duration && (
                  <Typography color="red">
                    {validationErrors.duration}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item md={6}></Grid>
            <Grid item md={6} sm={4} xs={9}>
              <FormControl fullWidth variant="outlined">
                <Typography id="leave-type-label" className="label_text">
                  Leave Reason <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  multiline
                  minRows={2}
                  fullWidth
                  placeholder="Type reason here..."
                  variant="outlined"
                  onChange={(e) => setReason(e.target.value)}
                />
                {!reason && validationErrors.reason && (
                  <Typography color="red">
                    {validationErrors.reason}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item md={6}></Grid>
            <Grid item md={6} sm={4} xs={9} style={{ marginBottom: "24px" }}>
              <FormControl fullWidth>
                <Button
                  size="large"
                  variant="contained"
                  id="submit_btn"
                  style={{
                    backgroundColor: "rgb(36, 77, 160)",
                    color: "white",
                    fontFamily: "MilliardMedium",
                    pointerEvents:
                      (selectedLeaves in remainingLeaves &&
                        remainingLeaves[selectedLeaves] < daycount) ||
                        daycount == 0 ||
                        preventDoubleClick
                        ? "none"
                        : "auto",
                    cursor:
                      (selectedLeaves in remainingLeaves &&
                        remainingLeaves[selectedLeaves] < daycount) ||
                        daycount == 0 ||
                        preventDoubleClick
                        ? "not-allowed"
                        : "pointer",
                    opacity:
                      (selectedLeaves in remainingLeaves &&
                        remainingLeaves[selectedLeaves] < daycount) ||
                        daycount == 0 ||
                        preventDoubleClick
                        ? 0.5
                        : 1,
                  }}
                  disabled={
                    (selectedLeaves in remainingLeaves &&
                      remainingLeaves[selectedLeaves] < daycount) ||
                    daycount == 0 ||
                    preventDoubleClick
                  }
                  onClick={() => handleSubmit()}
                >
                  Submit
                </Button>
              </FormControl>
            </Grid>
          </Grid>
        </form>
      </Card>

      <Dialog open={open}>
        <DialogContent>
          <center>
            <img src={Check} alt="" style={{ height: "50px", width: "50px" }} />
          </center>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              textAlign: "center",
              marginTop: "15px",
              color: "rgba(0, 0, 0, 0.66)",
            }}
          >
            Leave Applied Successfully.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleCancel()}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </ApplyLeaveStyle >
  );
}
